import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoginComponent } from "./core/components/login/login.component";
import { AuthGuard } from "./core/guards/auth.guard.service";

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "login",
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "dashboard",
    loadChildren: () =>
      import("./features/components/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "cards",
    loadChildren: () =>
      import("./features/components/user-list/user-list.module").then(
        (m) => m.UserListModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "contacts",
    loadChildren: () =>
      import("./features/components/contacts/contacts.module").then(
        (m) => m.ContactsModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "settings",
    loadChildren: () =>
      import("./features/components/settings/settings.module").then(
        (m) => m.SettingsModule
      ),
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
